<template>

    <Button icon="pi pi-file-export" class="mb-1 mr-1 ml-1" size="small" severity="help" label="Yazdır"
        @click="yazdirAlani()" />

   <!--  <div id="print-area">
       <div v-for="(ogunler, ogunAd) in gruplanmisVeri" :key="ogunAd" class="p-mb-3">
             <h3>{{ ogunAd }}</h3>
            <p-panel v-for="item in ogunler" :key="item.id" class="p-mb-2">
                <template #header>
                    {{ item.besin }}
                </template>
                <div>
                    {{ item.miktar }} {{ item.birim }}
                </div>
            </p-panel>
        </div>
    </div> -->



</template>

<script>
export default {
    data() {
        return {
            veri: [
                { id: 8, diyet: "Ketojenik", ogunKodu: 2, ogun: "Kuşluk Öğünü", besinId: 2, besin: "Köfte", birim: "Yemek Kaşığı", miktar: 1.0 },
                { id: 11, diyet: "Ketojenik", ogunKodu: 3, ogun: "Öğle Yemeği", besinId: 1, besin: "Mervimek Çorbası", birim: "Yemek Kaşığı", miktar: 50.0 },
                { id: 14, diyet: "Ketojenik", ogunKodu: 3, ogun: "Öğle Yemeği", besinId: 4, besin: "Pattes", birim: "Kova", miktar: 1.0 },
                { id: 15, diyet: "Ketojenik", ogunKodu: 1, ogun: "Sabah", besinId: 3, besin: "Elma", birim: "Kova", miktar: 30.0 },
                { id: 16, diyet: "Ketojenik", ogunKodu: 1, ogun: "Sabah", besinId: 5, besin: "Hoşaf", birim: "Kase", miktar: 4.0 },
                { id: 17, diyet: "Ketojenik", ogunKodu: 2, ogun: "Kuşluk Öğünü", besinId: 4, besin: "Pattes", birim: "Kova", miktar: 220.0 },
                { id: 19, diyet: "Ketojenik", ogunKodu: 3, ogun: "Öğle Yemeği", besinId: 5, besin: "Hoşaf", birim: "Kase", miktar: 20.0 },
                { id: 20, diyet: "Ketojenik", ogunKodu: 1, ogun: "Sabah", besinId: 2, besin: "Köfte", birim: "Yemek Kaşığı", miktar: 4.0 },
            ]
        }
    },
    computed: {
        gruplanmisVeri() {
            const ogunMap = {};
            for (const item of this.veri) {
                if (!ogunMap[item.ogun]) {
                    ogunMap[item.ogun] = [];
                }
                ogunMap[item.ogun].push(item);
            }
            return ogunMap;
        }
    },
    methods: {
        yazdirAlani() {
            // const printContent = document.getElementById('print-area').innerHTML;
            // const originalContent = document.body.innerHTML;

            // document.body.innerHTML = printContent;
            // window.print();
            // document.body.innerHTML = originalContent;
            // window.location.reload(); // layout'u geri getir








        }
    }
}
</script>